import { useTranslation } from 'react-i18next';
import { IoChevronDown, IoLanguageOutline } from 'react-icons/io5';

import { SUPPORTED_LANGUAGES } from '../../i18n';
import styles from './languageselector.module.css';

const LANGUAGE_LABEL_KEYS = {
  'pt-BR': 'language.portuguese',
  en: 'language.english',
  es: 'language.spanish',
};

function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const value = SUPPORTED_LANGUAGES.includes(i18n.resolvedLanguage)
    ? i18n.resolvedLanguage
    : 'pt-BR';

  return (
    <div className={styles.wrapper}>
      <label htmlFor="participant-language" className={styles.label}>
        {t('language.label')}
      </label>
      <div className={styles.control}>
        <IoLanguageOutline className={styles.languageIcon} aria-hidden="true" />
        <select
          id="participant-language"
          className={styles.select}
          value={value}
          onChange={(event) => i18n.changeLanguage(event.target.value)}
          aria-label={t('language.label')}
        >
          {SUPPORTED_LANGUAGES.map((language) => (
            <option key={language} value={language}>
              {t(LANGUAGE_LABEL_KEYS[language])}
            </option>
          ))}
        </select>
        <IoChevronDown className={styles.chevron} aria-hidden="true" />
      </div>
    </div>
  );
}

export default LanguageSelector;
